import "./summaryList.scss";

import PropTypes from 'prop-types';

function SummaryList(props) {
    const { leftColumn, rightColumn } = props;
    
    if (!leftColumn && !rightColumn) {
        return null;
    }
    
    return (
        <div className="summary-list-container">
            <div className="summary-list-container__column">
                {leftColumn}
            </div>
            <div className="summary-list-container__column">
                {rightColumn}
            </div>
        </div>
    );
}

SummaryList.propTypes = {
    leftColumn: PropTypes.element,
    rightColumn: PropTypes.element
};

export default SummaryList;
